<template>
  <filter-list
    ref="filterlist"
    :ready="!loadingOffers && !loadingFilters"
    :title="translations.filter_header_mobile"
    :tabs="translations.filter_tabs_mobile"
    @tabchange="(tab) => (shownFilterTab = tab)"
    @open="openChange"
  >
    <div class="filter-list__filters" v-show="shownFilterTab == 0">
      <offer-counter></offer-counter>
      <template v-if="!filterError">
        <price-filter :show-slider="showPriceFilter"></price-filter>
        <checkbox-filter
          :title="translations.direct_flight_title"
          :checkbox-name="translations.direct_flight_checkbox_title"
          filterValue="directFlight"
        ></checkbox-filter>
        <category-filter></category-filter>
        <dropdown-filter
          v-if="categoryFilters.boardTypes"
          :title="categoryFilters.boardTypes.title"
          :options="categoryFilters.boardTypes.options"
          :filter-name="categoryFilters.boardTypes.filtername"
          :filter-value="categoryFilters.boardTypes.filtervalue"
          :search="categoryFilters.boardTypes.searchable"
        ></dropdown-filter>
        <dropdown-filter
          v-if="categoryFilters.locations"
          :title="categoryFilters.locations.title"
          :options="categoryFilters.locations.options"
          :filter-name="categoryFilters.locations.filtername"
          :filter-value="categoryFilters.locations.filtervalue"
          :search="categoryFilters.locations.searchable"
        ></dropdown-filter>
        <dropdown-filter
          v-if="categoryFilters.roomLocated"
          :title="categoryFilters.roomLocated.title"
          :options="categoryFilters.roomLocated.options"
          :filter-name="categoryFilters.roomLocated.filtername"
          :filter-value="categoryFilters.roomLocated.filtervalue"
          :search="categoryFilters.roomLocated.searchable"
        ></dropdown-filter>
        <dropdown-filter
          v-if="categoryFilters.roomTypes"
          :title="categoryFilters.roomTypes.title"
          :options="categoryFilters.roomTypes.options"
          :filter-name="categoryFilters.roomTypes.filtername"
          :filter-value="categoryFilters.roomTypes.filtervalue"
          :search="categoryFilters.roomTypes.searchable"
        ></dropdown-filter>
        <keyword-checkbox
          :keywordCode="['transfer-MT', 'transfer-OT']"
          :title="translations.transfer_filter_title"
          :radio="true"
        ></keyword-checkbox>
        <keyword-checkbox
          :keywordCode="['inclusive-ZG']"
          :title="translations.transport_filter_title"
        ></keyword-checkbox>
        <keywords
          @keywordchange="() => $refs.filterlist.$emit('recalculate')"
          :excluded-keywords="['transfer-MT', 'inclusive-ZG', 'transfer-OT']"
        ></keywords>
        <checkbox-filter-list
          :title="translations.to_filter_title"
          :options="tourOperators"
          filter-name="tourOperator"
        ></checkbox-filter-list>
      </template>
    </div>
    <div class="filter-list__sort" v-show="shownFilterTab === 1">
      <search-sort @sortchange="closeFilterList()"></search-sort>
    </div>
  </filter-list>
</template>

<script>
import OfferCounter from "./offer-counter.vue";
import PriceFilter from "./filters/price-filter.vue";
import CategoryFilter from "./filters/category.vue";
import DropdownFilter from "./filters/dropdown-filter.vue";
import CheckboxFilter from "./filters/checkbox-filter.vue";
import Keywords from "./filters/keywords.vue";
import FilterList from "./filter-list.vue";
import SearchSort from "./search-sort.vue";
import CheckboxFilterList from "./filters/checkbox-list-filter.vue";
import KeywordCheckbox from "./filters/keyword-checkbox.vue";

import { scrollTo } from "scroll-js";
import _ from 'underscore';

export default {
  props: {
    loadingOffers: { type: Boolean, default: true },
    loadingFilters: { type: Boolean, default: false },
    filterError: { type: Boolean, default: false },
  },
  data() {
    return {
      translations: APP_CONFIG.TRANSLATION.HOTEL_AREA_FILTERS,
      dropdownFilters: APP_CONFIG.TRANSLATION.DROPDOWN_FILTERS,
      showPriceFilter: true,
      shownFilterTab: 0,
    };
  },
  methods: {
    openFilterList() {
      if (window.innerWidth <= 900) {
        this.$refs.filterlist.$emit("openView");
      }
    },
    openChange() {
      this.showPriceFilter = false;
      setTimeout(() => {
        this.showPriceFilter = true;
      }, 500);
    },
    closeFilterList() {
      this.$refs.filterlist.$emit("close");
      let scrollContainer =
        document.documentElement.scrollTop > 0
          ? document.documentElement
          : document.body;
      scrollTo(scrollContainer, { top: 0 });
    },
  },
  computed: {
    categoryFilters() {
      let dropdown_filters = this.dropdownFilters;
      let filters = _.pick(
        this.$store.state.filters,
        dropdown_filters.map((item) => item.filtername)
      );

      if (_.isEmpty(filters)) {
        return {};
      }

      let filterList = {};
      for (let i in filters) {
        let filtername = i;
        let dropdown_filter = dropdown_filters.filter(
          (dropdown_filter) => dropdown_filter.filtername == filtername
        );

        if (dropdown_filter[0]) {
          let title = dropdown_filter[0].title ? dropdown_filter[0].title : "";
          let searchable = dropdown_filter[0].search ? true : false;

          let options = [
            {
              text: dropdown_filter[0].default
                ? dropdown_filter[0].default
                : "All",
              value: "all",
            },
          ];

          options = options
            .concat(
              filters[i].map((filter) => {
                switch (filtername) {
                  case "locations":
                    return {
                      text: filter.name ? filter.name.toString() : null,
                      value: filter.id ? filter.id.toString() : null,
                    };
                  default:
                    return {
                      text: filter.name ? filter.name.toString() : null,
                      value: filter.code ? filter.code.toString() : null,
                    };
                }
              })
            )
            .filter((item) => item.text && item.value);

          if (options.length > 1) {
            filterList[filtername] = {
              title,
              filtervalue: dropdown_filter[0].filtervalue
                ? dropdown_filter[0].filtervalue
                : filtername,
              icon: filtername,
              options,
              filtername,
              searchable,
            };
          }
        }
      }

      return filterList;
    },
    tourOperators() {
      return this.$store.state.filters.tourOperators || [];
    },
  },
  components: {
    OfferCounter,
    PriceFilter,
    CategoryFilter,
    DropdownFilter,
    CheckboxFilter,
    Keywords,
    FilterList,
    SearchSort,
    CheckboxFilterList,
    KeywordCheckbox,
  },
};
</script>